export default "__VITE_ASSET__D$3HpjQa__"